@if (service.isOpen()) {
<div class="dialog-overlay" (click)="onBackdropClick()" (keydown)="onKeyDown($event)" tabindex="-1">
  <div class="dialog-container" (click)="$event.stopPropagation()">
    <!-- Dialog Header -->
    <div class="dialog-header">
      <h2>{{ service.config()?.title || getDefaultTitle() }}</h2>
      <button class="close-button" (click)="onCancel()" data-testid="dialog-close-button" type="button">
        ×
      </button>
    </div>

    <!-- Dialog Body -->
    <div class="dialog-body">
      <app-entity-list-selector [entityType]="service.currentEntityType()!" [mode]="service.config()?.mode || 'multi'"
        [preselected]="service.config()?.preselected || []" [showActions]="false"
        (selectionChange)="onSelectionChange($event)" (select)="onSelect($event)" />
    </div>

    <!-- Dialog Footer -->
    <div class="dialog-footer">
      <div class="selection-info">
        @if (selectedItems().length > 0) {
        <span>{{ selectedItems().length }} item{{ selectedItems().length === 1 ? '' : 's' }} selected</span>
        }
      </div>
      <div class="button-group">
        <app-button variant="outlined" (click)="onCancel()" data-testid="dialog-cancel-button">
          {{ getCancelText() }}
        </app-button>
        <app-button variant="filled" (click)="onConfirm()" [disabled]="isConfirmDisabled()"
          data-testid="dialog-confirm-button">
          {{ getConfirmText() }}
        </app-button>
      </div>
    </div>
  </div>
</div>
}